import styled, { css } from 'styled-components';

const dragActive = css`
    border-color: #1c0506;
`

const dragReject = css`
    border-color: #c32027;
`

const haveImage = css`
    border-color: #1c0506;
    background-color: #faf8f8;
`

export const DivAccordionMobile = styled.div`
    background: ${({ isDragging }) => isDragging ? '#faf8f8' : '#fff'};
    padding: 2rem 2rem;
    border-bottom: 1.5px solid rgba(196, 196, 196, 0.4);

    @media (max-width: 691px) {
        padding: 2rem 0
    }

    .switch-mobile {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center !important;
        h4 {
            margin: 0.25rem 0 0 1rem !important;
            padding: 0;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 550 !important;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #2a0709
        }
    }

    .collapsed-div {
        gap: 2rem;
    }

    .buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;

        button {
            width: 100%;
            outline: none;
            border: none;
            height: 2.5rem;
            border-radius: 2.5rem;
            font-size: 0.7rem;
            font-weight: 550;
            transition: all 0.2s ease-in-out;
        }

        .red {
            background: var(--red-100);
            color: var(--white);

            :hover {
                background: var(--red-200);
            }

            :active {
                background: var(--red-0);
            }
        }

        .white {
            background: var(--white);
            color: var(--red-200);
            border: 1.5px solid var(--red-200);

            :hover {
                background-color: var(--cor-neutra-100);
            }

            :active {
                background-color: var(--cor-neutra-500);
            }
        }
    }

    .texts {
        height: 48px;
        width: 100%;
        max-width: 144px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        span {
            font-family: Montserrat;
            font-size: 1rem;
        }
        .title {
            color: #a49b9b;
            font-weight: 400
        }
        .content {
            color: #2a0709;
            font-weight: 600;
            width: 100%;
            max-width: 144px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis
        }
    }

    .texts-switch {
        height: 56px;
        width: 100%;
        max-width: 144px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        span {
            font-family: Montserrat;
            font-size: 1rem;
        }
        .title {
            color: #a49b9b;
            font-weight: 400
        }
        .content {
            color: #2a0709;
            font-weight: 600;
            width: 100%;
            max-width: 144px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis
        }
    }

    .header-collapse {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        .left {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 1rem;
            .prod-img {
                border: 1px solid #dedede;
                opacity: 1;
                filter: grayscale(0);
                transition: all 1s;
                width: 48px;
                height: 48px;
                border-radius: 4px;
                overflow: hidden;
                object-fit: cover;
            }
            .prod-img-gray {
                border: 1px solid #dedede;
                opacity: 0.8;
                filter: grayscale(1);
                transition: all 1s;
                width: 48px;
                height: 48px;
                border-radius: 4px;
                overflow: hidden;
                object-fit: cover;
            }
            .icon-reorder {
                color: #a49b9b;
                width: 1rem;
                height: 1rem;
                font-size: 1rem;
            }
        }

        .right {
            .icon {
                cursor: pointer;
                width: 22px;
                height: 22px;
                .chevron {
                    transition: 0.3s transform;
                    -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                    transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                }
            }
        }
    }
`

export const DivAccordion = styled.div`
            white-space: nowrap;
            border-radius: 0.5rem;
            background-color: ${({isDragging}) => isDragging ? 'var(--cor-neutra-100)' : 'var(--white)'};
            cursor: default;
            display: flex;
            width: 50%;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 42px;
            padding-left: 32px;

            @media (max-width: 691px) {
                width: 100%;
                padding: 0.75rem 0 !important;

                .categ-name {
                    width: 108px;
                }

                h3 .categoria {
                    @media(max-width: 691px) {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }

            div {
                display: flex;
                flex-direction: row
            }

            h4 {
                margin: 0;
                font-family: Montserrat;
                font-size: 16px;
                font-weight: 700;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                overflow: hidden;
                white-space:nowrap;
                text-overflow:ellipsis;
                max-width:50%;
                display:inline-block;
            }

            .icon {
                cursor: pointer;
                width: 22px;
                height: 22px;
                padding: 0 16px;

                @media (max-width: 691px) {
                    padding: 0 0.5rem;
                }

                .chevron {
                    transition: 0.3s transform;
                    -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                    transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                }
            }
`

export const DropContainer = styled.div.attrs({
    className: "dropzone"
})`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    outline: none;
    height: 224px;
    width: 100%;
    max-width: 511px;
    border: 2px dashed #a09c9d;
    border-radius: 8px;
    cursor: pointer;

    transition: height 0.2s ease;

    ${props => props.haveImage && haveImage};
    ${props => props.isDragActive && dragActive};
    ${props => props.isDragReject && dragReject};

    font-family: Montserrat;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: normal;
    font-size: 16px;

    .icon-image {
        margin-bottom: 24px;
    }

    .bold {
        font-weight: 600;
    }

    .nome {
        margin-bottom: 16px;
        font-weight: 700;
        width: 88%; 
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1; /* number of lines to show */
        -webkit-box-orient: vertical;
    }
`;

const messageColors = {
    default: '#2a0709',
    error: '#c32027',
    success: '#1c0506',
};

export const UploadMessage = styled.div`
    display: flex;
    flex-direction: column;
    color: ${props => messageColors[props.type || 'default']};
    justify-content: center;
    align-items: center;
`;

export const StyledTbody = styled.tbody`
    cursor: pointer;
    background-color: ${props => (props.isDragging ? '#faf8f8' : '#fff')};
    :hover {
            background-color: #faf8f8
        }
    tr {
        cursor: pointer;
    }
`

export const Container = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f0f0f0;
    align-items: center;
    // -webkit-touch-callout: none;
    // -webkit-user-select: none;
    // -khtml-user-select: none;
    // -moz-user-select: none;
    // -ms-user-select: none;
    // user-select: none;
    -webkit-tap-highlight-color: transparent;

    .data-rbd-drag-handle-context-id {
        cursor: pointer
    }

    .h5-inside-map {
        padding: 32px;
    }
    .h5-inside-card {
        padding: 0;
    }

    .cards-container {
        padding: 2rem 1rem 2rem 2rem;
        padding-bottom: 36px;
        display: flex;
        flex-wrap: wrap;
        flex: 0 0 33%;

        @media (max-width: 691px) {
            padding: 2rem 1rem 2rem 0;
        }
    }

    .card-item {
        background-color: #fff;
        margin: 0 16px 16px 0;
        padding: 16px;
        box-sizing:border-box;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        max-width: 328px;
        height: 120px;
        border-radius: 8px;
        border: 1px solid #dedede;

        .foto {
            .prod-img {
                opacity: 1;
                filter: grayscale(0);
                transition: all 1s;
                width: 48px;
                height: 48px;
                border-radius: 4px;
                overflow: hidden;
                object-fit: cover;
            }

            .prod-img-gray {
                opacity: 0.8;
                filter: grayscale(1);
                transition: all 1s;
                width: 48px;
                height: 48px;
                border-radius: 4px;
                overflow: hidden;
                object-fit: cover;
            }
        }

        div {
            display: flex;
            flex-direction: column;
        }

        .title {
            color: #acaaab;
            font-weight: 500;
            font-size: 12px;
            font-family: Montserrat;
        }

        .a-partir-de{
            font-size: 11px;
            transition: all 1s;
            color: #321e1d;
            font-weight: 500;
            font-family: Montserrat;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical; 
        }

        .content {
            transition: all 1s;
            color: #321e1d;
            font-weight: 500;
            font-size: 12px;
            font-family: Montserrat;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical; 
        }

        .content-gray {
            transition: all 1s;
            color: #a49b9b;
            font-weight: 500;
            font-size: 12px;
            font-family: Montserrat;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical; 
        }

        .meio {
            height: 100%;
            width: 104px;
            padding-left: 8px;
            justify-content: space-between;
        }

        .fim {
            height: 100%;
            width: 104px;
            padding-left: 8px;
            justify-content: space-between;
        }

        :hover {
            border: 1px solid #110908;
        }

        .more-button {
            position: absolute;
            right: 6px;
            top: 6px;
            cursor: pointer;
            height: 32px;
            width: 32px;
            outline: none;
            border: none;
            border-radius: 32px;
            background-color: transparent;
            justify-content: center;
            align-items: center;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 600;
            transition: 0.2s;
            padding: 0;
            padding-top: 4px;
            .icon {
            color: #a49b9b;
            width: 18px;
            height: 18px;
                align-self: center;
            }
            /* :hover {
                color: #9c1a1f
            } */
            :active {
                background-color: #dedede
                }           
                /* @media(max-width: 691px) {
                    width: 100%;
                } */
            }

            .menu {
                font-size: 16px;
                font-family: Montserrat;
                transition: all 0.2s;
                display: flex;
                align-self: center;
                flex-direction: column;
                position: absolute;
                justify-content: center;
                color: #7a6d6d !important;
                background-color: #fff;
                -webkit-box-shadow: 0px 13px 25px -6px rgba(0,0,0,0.07);
                -moz-box-shadow: 0px 13px 25px -6px rgba(0,0,0,0.07);
                box-shadow: 0px 13px 25px -6px rgba(0,0,0,0.07);
                z-index: 5;
                width: 205px;
                border-radius: 8px;
                top: 76px;
                right: 8px;
                span {
                    color: #7a6d6d !important;
                    font-size: 16px;
                    font-family: Montserrat;
                }
                .item {
                    font-weight: 450;
                    color: #7a6d6d !important;
                    display: flex;
                    flex-direction: column;
                    justify-content: left;
                    background-color: #fff;
                    cursor: pointer;
                    :hover {
                        font-weight: 500;
                        color: #3f2829 !important;
                        background-color: #faf8f8
                    }
                    span {
                        padding: 16px;
                    }
                }
                .item-disabled {
                    font-weight: 450;
                    display: flex;
                    flex-direction: column;
                    justify-content: left;
                    background-color: #fff;
                    span {
                        padding: 16px;
                    }
                }
            }
    }

    .td-empty {
        padding: 0;
        border: none;
    }

    .menu {
        font-size: 16px;
        font-family: Montserrat;
        transition: all 0.2s;
        display: flex;
        color: #7a6d6d !important;
        align-self: center;
        flex-direction: column;
        position: absolute;
        justify-content: center;
        background-color: #fff;
        -webkit-box-shadow: 0px 13px 25px -6px rgba(0,0,0,0.07);
        -moz-box-shadow: 0px 13px 25px -6px rgba(0,0,0,0.07);
        box-shadow: 0px 13px 25px -6px rgba(0,0,0,0.07);
        z-index: 5;
        width: 205px;
        border-radius: 8px;
        margin-top: -26px;
        right: 24px;

        .item {
            font-weight: 450;
            display: flex;
            flex-direction: column;
            justify-content: left;
            background-color: #fff;
            cursor: pointer;
            :hover {
                font-weight: 500;
                color: #3f2829;
                background-color: #faf8f8
            }
            span {
                padding: 16px;
            }
        }
        .item-disabled {
            font-weight: 450;
            display: flex;
            flex-direction: column;
            justify-content: left;
            background-color: #fff;
            span {
                padding: 16px;
            }
        }
    }

    .del-button {
        cursor: pointer;
        outline: none;
        border: none;
        background-color: transparent;
        justify-content: center;
        align-items: center;
        transition: 0.2s;

        .icon {
            color: #a49b9b;
            width: 16px;
            height: 16px;
            align-self: center;
        }

        /* :hover {
            color: #9c1a1f
        } */
        /* :active {
            background-color: #dedede
        } */
        
        /* @media(max-width: 691px) {
            width: 100%;
        } */
    }

    

                        .switch {
                            width: 106px;
                            cursor: pointer;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            h4 {
                                margin: 0;
                                margin-left: 16px;
                                padding: 0;
                                font-family: Montserrat;
                                font-size: 16px;
                                font-weight: 400;
                                font-stretch: normal;
                                font-style: normal;
                                line-height: 1;
                                letter-spacing: normal;
                                text-align: left;
                                color: #2a0709
                            }
                        }

                    table {
                        width: 100%;
                        margin: 0;
                        margin-bottom: 2rem;
                        font-family: Montserrat;
                        text-align: left;
                        font-size: 16px;
                        border: none;
                        border-collapse: collapse;

                        td {
                            max-width: 196px;
                            color: #2a0709;
                            padding: 24px 0;
                            padding-right: -32px;
                            border: none;
                            border-top: 2px solid #f3f3f3;

                            :first-child {
                                padding-left: 32px;
                            }

                            /* span {
                                color: #2a0709;
                            } */

                            .switch {
                                cursor: pointer;
                                display: flex;
                                flex-direction: row;
                                align-items: center;

                                h4 {
                                    margin: 0;
                                    margin-left: 16px;
                                    padding: 0;
                                    font-family: Montserrat;
                                    font-size: 16px;
                                    font-weight: 400;
                                    font-stretch: normal;
                                    font-style: normal;
                                    line-height: 1;
                                    letter-spacing: normal;
                                    text-align: left;
                                    color: #2a0709
                                }
                            }

                            .prodImg {
                                opacity: 1;
                                filter: grayscale(0);
                                transition: all 1s;
                                width: 48px;
                                height: 48px;
                                border-radius: 4px;
                                overflow: hidden;
                                object-fit: cover;
                            }

                            .prodImg-gray {
                                opacity: 0.8;
                                filter: grayscale(1);
                                transition: all 1s;
                                width: 48px;
                                height: 48px;
                                border-radius: 4px;
                                overflow: hidden;
                                object-fit: cover;
                            }
                        }

                        .th-drag {
                            width: 7.29%;
                        }

                        .th-img {
                            width: 11.13%
                        }

                        .th-nome {
                            width: 31.93%;
                        }

                        .th-descricao {
                            width: 20.80%;
                        }

                        .th-valor {
                            width: 11.95%;
                        }

                        .th-switch {
                            width: 16.87%;
                        }

                        .td-drag {
                            width: 7.29%;
                            padding-right: 32px;

                            .icon {
                                color: #a49b9b;
                                width: 16px;
                                height: 16px;
                            }
                        }

                        .td-img {
                            width: 11.13%
                        }

                        .td-nome {
                            transition: all 1s;
                            width: 31.93%;
                            font-weight: 600;
                            color: #2a0709;
                        }

                        .td-nome-gray {
                            transition: all 1s;
                            width: 31.93%;
                            font-weight: 600;
                            color: #a49b9b !important
                        }

                        .td-descricao {
                            transition: all 1s;
                            width: 20.80%;
                            padding: 0;
                            padding-right: 32px;
                            align-self: center;
                            font-family: Montserrat;
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 1.5;
                            text-align: left;
                            color: #2a0709;
                        }

                        .td-descricao-gray {
                            transition: all 1s;
                            width: 20.80%;
                            padding: 0;
                            padding-right: 32px;
                            align-self: center;
                            font-family: Montserrat;
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 1.5;
                            text-align: left;
                            color: #a49b9b !important;
                        }

                        .td-valor {
                            transition: all 1s;
                            width: 11.95%;
                            font-weight: 600;
                            color: #2a0709
                        }

                        .td-valor-gray {
                            transition: all 1s;
                            width: 11.95%;
                            font-weight: 600;
                            color: #a49b9b
                        }

                        .a-partir-de{
                            font-size: 11px
                        }

                        .td-switch {
                            width: 16.87%;

                            div {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;

                                .more-button {
                                    cursor: pointer;
                                    height: 32px;
                                    width: 32px;
                                    outline: none;
                                    border: none;
                                    border-radius: 32px;
                                    background-color: transparent;
                                    justify-content: center;
                                    align-items: center;
                                    font-family: Montserrat;
                                    font-size: 16px;
                                    font-weight: 600;
                                    transition: 0.2s;
                                    padding-top: 5px;
                                    margin-right: 32px;

                                    .icon {
                                        color: #a49b9b;
                                        width: 22px;
                                        height: 22px;
                                        align-self: center;
                                    }

                                    /* :hover {
                                        color: #9c1a1f
                                    } */
                                    :active {
                                        background-color: #dedede
                                    }
                                    
                                    /* @media(max-width: 691px) {
                                        width: 100%;
                                    } */
                                } 
                            }
                        }

                        tbody {
                            cursor: default
                        }

                        th {
                            font-weight: normal;
                            padding: 34px 0;
                            padding-right: -32px;
                            border: none;
                            border-bottom: 2px solid #f3f3f3;
                        }

                        thead {
                            color: #a49b9b;
                        }
                }

    .spinner {
        position: absolute;
        right: 25px;
        top: 24px;
        background-color: transparent;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;
        @media(max-width: 691px) {
            top: 24px;
            right: 47%;
        }
    }

    .celular {
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: center;
        justify-content: center;

        .tabs {
            position: absolute;
            top: 509px
        }

        .top-tab {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background-color: #cb3c32;
        width: 100%;
        height: 72px;

        .div-nome {
            display: flex;
            flex-direction: row;
            align-items: center;
            align-self: center;
            justify-content: center;
        }

        .icon {
            padding: 16px 16px;
        }

        .nome-celular {
            max-width: 260px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1; /* number of lines to show */
            -webkit-box-orient: vertical;
            padding: 8px 8px;
            font-family: Arial, Helvetica, sans-serif;
            color: #dedede;
        }
    }

        .descricao {
            position: absolute;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2; /* number of lines to show */
            -webkit-box-orient: vertical;
            font-family: Arial, Helvetica, sans-serif;
            color: #737373;
            top: 443px;
            max-width: 260px;
        }

        img {
            height: 100%;
            width: 100%;
            overflow: hidden;
            object-fit: cover;
        }

        .capa {
            outline: none;
            background-color: #fff;
            overflow: hidden;
            width: 100%;
            height: 254px;
        }

        .logo {
            outline: none;
            border: 1px solid #dedede;
            background-color: #fff;
            overflow: hidden;
            width: 138px;
            height: 138px;
            position: absolute; 
            top: 281px;
            border-radius: 8px;
            align-self: center;
        }
    }

    .div-invalido {
        width: 95%;
        max-width: 540px;
        overflow: hidden;
        box-sizing: border-box;
        top: 0px;
        margin-bottom: 16px;

        .texto-invalido {
            font-family: Montserrat;
            font-size: 12px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            color: #c42027;
            float: left;
            cursor: default;
        }
    }

    p {
        margin: 0
    }

    .infos {
        display: flex;
        flex-direction: row;
        padding: 0 32px;
        margin-bottom: -72px;

        @media(max-width: 691px) {
            margin-bottom: -56px;
            padding: 0 16px;
        }

        .left {
            width: 50%;

            @media(max-width: 1200px) {
                width: 100%;
            }

            .dropzones {

                @media (max-width: 1200px) {
                    display: none
                }
            }

            .frame {
                display: none;
                position: relative;
                margin: 32px 0;
                width: 280px;
                height: 393px;

                @media (max-width: 1200px) {
                    display: block;
                }

                .celular {
                    display: flex;
                    border-radius: 8px;
                    flex-direction: column;
                    align-items: center;
                    align-self: center;
                    justify-content: center;

                    .tabs {
                        position: absolute;
                        bottom: 0
                    }

                    .tab {
                        border-top-right-radius: 8px;
                        border-top-left-radius: 8px;
                    }

                    .top-tab {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    background-color: #cb3c32;
                    width: 100%;
                    height: 52px;

                    .div-nome {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        align-self: center;
                        justify-content: center;
                    }

                    .icon {
                        padding: 8px 8px;
                    }

                    .nome-celular {
                        max-width: 170px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1; /* number of lines to show */
                        -webkit-box-orient: vertical;
                        padding: 8px 8px;
                        font-family: Arial, Helvetica, sans-serif;
                        font-size: 14px;
                        color: #dedede;
                    }
                }

                    .descricao {
                        position: absolute;
                        text-align: center;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2; /* number of lines to show */
                        -webkit-box-orient: vertical;
                        font-family: Arial, Helvetica, sans-serif;
                        font-size: 12px;
                        color: #606060;
                        top: 311.2px;
                        padding: 0 32px;
                        max-width: 260px;
                    }

                    img {
                        height: 100%;
                        width: 100%;
                        overflow: hidden;
                        object-fit: cover;
                    }

                    .capa {
                        cursor: pointer;
                        position: relative;
                        outline: none;
                        background-color: #fff;
                        overflow: hidden;
                        width: 100%;
                        height: 178px;

                        .process-capa {
                            position: absolute;
                            right: 0;
                            bottom: 0;
                        }
                    }

                    .logo {
                        cursor: pointer;
                        position: relative;
                        outline: none;
                        border: 1px solid #dedede;
                        background-color: #fff;
                        overflow: hidden;
                        width: 96px;
                        height: 96px;
                        position: absolute; 
                        top: 194px;
                        border-radius: 8px;
                        align-self: center;

                        .process-logo {
                            position: absolute;
                            right: 0;
                            bottom: 0;
                        }
                    }
                }
            }
        }

        .right {
            width: 50%;
            padding-left: 32px;
            display: flex;
            flex-direction: column;
            align-items:center;
            justify-content: flex-start;
            padding-top: 150px;
            position: relative;

            @media(max-width: 1200px) {
                display: none;
            }

            .branco {
                z-index: 5;
                position: absolute;
                top: 811px;
                width: 470px;
                height: 561px;
                background-color: #fff
            }
        }
    }

    .minimo {
        padding: 0 32px;

        @media(max-width: 691px) {
            padding: 0 16px;
        }
    }

    .cozinhas {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;

        .cozinha {
            margin-bottom: 16px;
            margin-right: 16px;
            background-color: #faf8f9;
            border: 2px solid #a39a9b;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 100px;

            @media (max-width: 690px) {
                margin-bottom: 8px;
                margin-right: 8px;
            }

            span {
                text-align: center;
                color: #a39a9b;
                font-family: Montserrat;
                font-size: 16px;
                font-weight: 600;
                padding: 12px 32px;

                @media (max-width: 690px) {
                    font-size: 12px;
                    padding: 8px 12px;
                }
            }
        }
    }

    .tempo {
        padding: 0 32px;

        @media(max-width: 691px) {
            padding: 0 16px;
        }
    }

    .retirada {
        padding: 0 32px;

        @media(max-width: 691px) {
            padding: 0 16px;
        }

        h6 {
            color: #c0b7b8;
            line-height: 2;
            font-weight: normal;
            font-family: Montserrat;
            font-size: 12px;
            text-align: left;
        }

        .aberto-fechado {
            cursor: pointer;
            display: flex;
            flex-direction: row;
            align-items: center;
            h4 {
                margin: 0;
                margin-left: 16px;
                padding: 0;
                font-family: Montserrat;
                font-size: 16px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #2a0709
            }
        }
    }

    .categorias-e-produtos {
        padding: 0;

        h3 {
            font-size: 1rem;
            font-family: Montserrat;
            margin: 0;
            font-weight: 500;
            padding-left: 8px;
        }

        h5 {
            padding-left: 32px;
        }

        .categoria {
            white-space: pre-wrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0;
            font-weight: 700;
            padding-left: 2rem;

            @media (max-width: 691px) {
                padding-left: 0
            }
        }

        .modos {
            display: flex;
            padding: 3.5rem 2rem 1rem 2rem;
            align-items: center;

            @media (max-width: 691px) {
                padding: 2.5rem 0 0
            }

            .card {
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .lista {
                cursor: pointer;
                padding-left: 2rem;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        @media(max-width: 691px) {
            padding: 0 16px;
        }
    }

    .produtos {
        padding: 0 32px;

        @media(max-width: 691px) {
            padding: 0 16px;
        }
    }
    
    .titulo {
        padding: 0 2rem;

        @media(max-width: 691px) {
            padding: 0 1rem;
        }
    }

    .div-input {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-bottom: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 691px) {
            height: 64px;
        }
    }

    .div-input-disabled {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-bottom: 40px;
        padding: 0;
        box-sizing: border-box;
        background-color: #faf8f9;

        @media(max-width: 691px) {
            height: 64px;
        }
    }

    .div-input-focado {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #1c0506;
        margin-bottom: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 691px) {
            height: 64px;
        }
    }

    .div-input-error {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #c32027;
        margin-bottom: 8px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 691px) {
            height: 64px;
        }
    }

    .div-input input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }

        @media(max-width: 691px) {
            padding-top: 8px;
        }
    }

    .div-input-disabled input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }

        @media(max-width: 691px) {
            padding-top: 8px;
        }
    }

    .div-input-focado input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 691px) {
            padding-top: 8px;
        }
    }

    .div-input-error input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #c42027;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 691px) {
            padding-top: 8px;
        }
    }

    .div-input label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 691px) {
            bottom: 12px;
        }
    }

    .div-input-disabled label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 691px) {
            bottom: 12px;
        }
    }

    .div-input-focado label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 691px) {
            bottom: 12px;
        }
    }

    .div-input-error label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 691px) {
            bottom: 12px;
        }
    }

    .div-input label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-disabled label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-focado label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-error label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .content-name {
        position: absolute;
        bottom: 8px;
        left: 0px;
        transition: all 0.3s ease;
    }

    .div-input input:focus + .label-name .content-name,
    .div-input input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-disabled input:focus + .label-name .content-name,
    .div-input-disabled input:valid + .label-name .content-name,
    .div-input-disabled input:disabled + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-focado input:focus + .label-name .content-name,
    .div-input-focado input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-focado::after {
            border: none;
        }
    }

    .div-input-error input:focus + .label-name .content-name,
    .div-input-error input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-error::after {
            border: none;
        }
    }

    .div-input input:focus + .label-name::after,
    .div-input input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-disabled input:focus + .label-name::after,
    .div-input-disabled input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-focado input:focus + .label-name::after,
    .div-input-focado input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-error input:focus + .label-name::after,
    .div-input-error input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 691px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-disabled button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 691px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-focado button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 691px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-error button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 691px) {
            font-size: 18px;
            top: 20px
        }
    }

    .botao {
        display: flex;
        margin: 2rem 0 0 2rem;
        border-bottom: 1.5px solid #dedede;
        margin: 64px 32px;

        @media(max-width: 691px) {
            margin: 30px 0 20px 0;
            padding: 1rem;
            border-bottom: 1.5px solid #dedede;
        }
            
        .salvar {
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #c32027;
            outline: none;
            border: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #9c1a1f
            }

            :active {
                background-color: #d7232c
            }
            
            @media(max-width: 691px) {
                width: 100%;
                border-bottom: none;
                margin-top: 0px;
                margin-bottom: 30px;
            } 
        }

        .salvar-branco {
            margin-bottom: 64px; 
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #fff;
            border: 1px solid #c32027;
            outline: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #c32027;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #faf8f8
            }

            :active {
                background-color: #dedede
            }
            @media(max-width: 691px) {
                width: 100%;
                margin-bottom: 48px;
            }
        }
    }

    .botao-sem-linha {
        display: flex;
        margin: 2rem 0 0 2rem;

        @media(max-width: 691px) {
            margin: 30px 0 20px 0;
            padding: 1rem;
            
        }
            
        .salvar {
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #c32027;
            outline: none;
            border: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #9c1a1f
            }

            :active {
                background-color: #d7232c
            }
            
            @media(max-width: 691px) {
                width: 100%;
                border-bottom: none;
                margin-top: 0px;
                margin-bottom: 0px;
            } 
        }
    }

    .botao-sem-linha2 {
        display: flex;
        margin: 2rem 0 3rem 2rem;

        @media(max-width: 691px) {
            margin: 30px 0 50px 0;
            padding: 1rem 0;
            
        }
            
        .salvar {
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #c32027;
            outline: none;
            border: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #9c1a1f
            }

            :active {
                background-color: #d7232c
            }
            
            @media(max-width: 691px) {
                width: 100%;
                border-bottom: none;
                margin-top: 0px;
                margin-bottom: 0px;
            } 
        }
    }
    
        hr {
            display: block; 
            height: 1px;
            border: 0; 
            border-top: 2px solid #f3f3f3;
            margin: 4rem 0;
            padding: 0;

            @media(max-width: 691px) {
                margin: 56px 0px;
            }
        }

        .linha {
            border-left: none;
            border-top: 2px solid #f3f3f3;
            margin: 64px 32px;

            :last-child {
                border-top: 0px solid #fff;
                margin: 64px
            }

            @media(max-width: 691px) {
                margin: 56px 0px;
            }
        }

        // .linha1 {
        //     border-left: none;
        //     border-top: 2px solid #f3f3f3;
        //     margin: 64px 32px;

        //     :last-child {
        //         border-top: 0px solid #fff;
        //         margin: 64px
        //     }

        //     @media(max-width: 691px) {
        //         display: none;
        //     }
        // }

        h2 {
                padding-left: 32px;
                margin-bottom: 24px;
                font-family: Montserrat;
                font-size: 24px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                
                @media(max-width: 691px) {
                    font-size: 16px;
                    margin: 0;
                    padding: 0
                }
            }

    .div-pai {
        margin: 32px;
        background-color: #fff;
        max-width: 1096px;
        min-width: 300px;
        width: 88%;
        border-radius: 8px;
        padding-bottom: 72px;

        @media (max-width: 1330px) {
            margin-bottom: 80px;
        }

        @media (max-width: 690px) {
            margin-top: 161px;
        }

        @media(max-width: 691px) {
            margin: 24px;
            margin-top: 153px;
            margin-bottom: 80px;
        }

        .div-rota {
            margin-right: 16px;
            margin-top: 40px;
            margin-left: 32px;
            width: 90%;
            overflow: hidden;
            white-space:nowrap;
            text-overflow: ellipsis;

            @media(max-width: 691px) {
                margin-left: 16px
            }
            
            span {
                font-family: Montserrat;
                font-size: 14px;
                color: #2a0709;
                font-weight: 500;

                @media(max-width: 691px) {
                    font-size: 12px;
                }
            }

            .rotas {
                font-family: Montserrat;
                font-size: 14px;
                color: #a49b9b;
                font-weight: normal;

                @media(max-width: 691px) {
                    font-size: 12px;
                }
            }
        }

        .emoji {
            width: 32px;
            height: 32px;
            margin-top: 40px;
            margin-bottom: 24px;
            object-fit: contain;

            @media(max-width: 691px) {
                    margin-top: 32px
                }
        }

        h1 {
            font-family: Montserrat;
            font-size: 32px;
            margin-top: 0;
            margin-bottom: 24px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 691px) {
                font-size: 24px;
            }
        }

        h5 {
            padding-right: 42px;
            margin-bottom: 56px;           
            font-family: Montserrat;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #a49b9b;

            @media(max-width: 691px) {
                margin-bottom: 2rem;
                padding: 0   
            }
        }

        h4 {
            margin-top: 64px;
            margin-bottom: 40px;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 691px) {
                margin-top: 40px;
                margin-bottom: 24px;
            }
        }

        .pages {
            width: 100%;
            padding-left: 8px;
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 56px;

            .page {
                background-color: #fff;
                margin-left: 24px;
                margin-top: 24px;
                cursor: pointer;
                width: 100%;
                max-width: 382px;
                border-radius: 8px;
                border: 1.5px solid #dedede;

                @media (max-width: 510px) {
                    width: 80%;
                }

                @media (max-width: 691px) {
                    margin-left: 8px;
                    margin-top: 16px;
                    width: 89%;
                }

                .emoji {
                    margin-top: 32px;
                    margin-left: 32px;

                    @media(max-width: 691px) {
                            margin-left: 16px;
                        }
                }

                .botao {
                    display: flex;
                    width: 100%;
                    padding-left: 32px;
                    margin-bottom: 32px;

                    @media(max-width: 510px) {
                        padding-left: 0px;
                        align-items: center;
                        justify-content: center;
                    }

                    .salvar {
                        cursor: pointer;
                        height: 40px;
                        width: 92px;
                        background-color: #fff;
                        outline: none;
                        border: none;
                        border-radius: 20px;
                        justify-content: center;
                        align-items: center;
                        color: #c42027;
                        border: 1.5px solid #c42027;
                        font-family: Montserrat;
                        font-size: 11px;
                        font-weight: 600;
                        transition: 0.2s;

                        :hover {
                            background-color: #faf8f8
                        }

                        :active {
                            background-color: #dedede
                        }

                        @media(max-width: 510px) {
                            width: 83%;
                        }

                        @media(max-width: 691px) {
                            width: 90%;
                            height: 32px;
                        }
                    }

                    .salvar-branco {
                        /* margin-bottom: -56px;  */
                        margin-left: 32px;
                        cursor: pointer;
                        height: 40px;
                        width: 160px;
                        background-color: #fff;
                        border: 1px solid #c32027;
                        outline: none;
                        border-radius: 20px;
                        justify-content: center;
                        align-items: center;
                        color: #c32027;
                        font-family: Montserrat;
                        font-size: 11px;
                        font-weight: 600;
                        @media(max-width: 691px) {
                            width: 100%;
                        }
                    }
                }

                :hover {
                    border: 1.5px solid #a49a9b;
                    -webkit-box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
                    -moz-box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
                    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);

                    .salvar {
                        background-color: #c32027;
                        color: #fff;
                    }
                }

                h4 {
                    margin: 0;
                    padding-left: 32px;
                    padding-bottom: 16px;

                    @media (max-width: 691px) {
                        padding-left: 16px;
                    }
                }

                h5 {
                    font-size: 12px;
                    margin: 0;
                    line-height: 1.5;
                    padding-left: 32px;
                    padding-right: 16px;
                    padding-bottom: 16px;

                    @media (max-width: 691px) {
                        padding-left: 16px;
                    }
                }
            }
        }
    }
`

export const Filtro = styled.div`
            display: flex;
            flex-direction: column;
            width: 88%;
            padding-top: 2rem;
            padding-bottom: 2rem;

            @media(max-width: 691px) {
                width: 100%;
            }

            .box {
                cursor: pointer;
                border: 1.5px solid #ececec;
                border-radius: 100px;
                width: 252px;
                height: 64px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                @media (max-width: 691px) {
                    width: 88%;
                    height: 56px;
                    align-self: center;
                }

                :hover{
                    background-color: #ececec
                }

                .left {
                    display: flex;
                    flex-direction: row;
                    padding-left: 1rem;
                    align-items: center;

                    h5 {
                        margin: 0;
                        padding: 0 1rem;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 500;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #000000;
                    }
                }

                .chevron {
                    padding-right: 32px;
                    transition: 0.3s transform;
                    -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                    transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                }
            }

            .textos {
                max-width: 620px;
                /* margin-left: 32px; */
                margin-right: 16px;
                margin-top: 32px;
                transition: opacity 0.2s ease-in-out;
                -webkit-transition: opacity 0.2s ease-in-out;
                -moz-transition: opacity 0.2s ease-in-out;
                -ms-transition: opacity 0.2s ease-in-out;
                -o-transition: opacity 0.2s ease-in-out;

                @media (max-width: 691px) {
                    margin: 0 16px;
                    margin-top: 16px;
                }

                h5 {
                    margin: 0;
                    padding: 0;
                    font-family: Montserrat;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 2.29;
                    letter-spacing: normal;
                    text-align: left;
                    color: #a49b9b
                }
            }
`

export const Atencao = styled.div`
            display: flex;
            flex-direction: column;
            margin-left: 32px;
            width: 88%;

            @media(max-width: 691px) {
                margin-left: 0;
                width: 100%;
            }

            .box {
                border: 1.5px solid #ececec;
                border-radius: 100px;
                width: 185px;
                height: 64px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;

                @media (max-width: 691px) {
                    width: 88%;
                    height: 56px;
                    align-self: center;
                }

                .left {
                    display: flex;
                    flex-direction: row;
                    //padding-left: 32px;
                    align-items: center;

                    .alerta {
                        width: 24px;
                        height: 24px;
                    }

                    h5 {
                        margin: 0;
                        padding: 0 16px;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 600;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #000000;
                    }
                }

                .chevron {
                    padding-right: 32px;
                    transition: 0.3s transform;
                    -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                    transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                }
            }

            .textos {
                max-width: 620px;
                /* margin-left: 32px; */
                margin-right: 16px;
                margin-top: 32px;
                transition: opacity 0.2s ease-in-out;
                -webkit-transition: opacity 0.2s ease-in-out;
                -moz-transition: opacity 0.2s ease-in-out;
                -ms-transition: opacity 0.2s ease-in-out;
                -o-transition: opacity 0.2s ease-in-out;

                @media (max-width: 691px) {
                    display:none;
                }

                h5 {
                    margin: 0;
                    padding: 0;
                    font-family: Montserrat;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 2.29;
                    letter-spacing: normal;
                    text-align: left;
                    color: #a49b9b
                }
            }

            .textos-mobile {
                display: none;

                @media (max-width: 691px) {
                    display: flex;
                    margin: 0 16px;
                    margin-top: 16px;
                }

                h5 {
                    margin: 0;
                    padding: 0;
                    font-family: Montserrat;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 2.29;
                    letter-spacing: normal;
                    text-align: left;
                    color: #a49b9b
                }
            }
`